{
  "newVersion": "New Version Available",
  "message1": "There is an updated version of $t(common:companyName).",
  "message2": "to load the latest version.",
  "refresh": "Refresh"
}
